import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const deleteSubCategoryAction = createAsyncThunk(
    'delete-sub-category',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/delete-sub-category`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const deleteSubCategorySlice = createSlice({
    name: 'delete-sub-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(deleteSubCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(deleteSubCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(deleteSubCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const deleteSubCategoryReducer = deleteSubCategorySlice.reducer    